import type { ReactNode } from "react";
import { cn } from "../tokens.js";

export function Rail({ children, className }: { children: ReactNode; className?: string }) {
  return <div className={cn("ui-rail", className)}>{children}</div>;
}
